const initialState = {
    cities: [],
    filials: [],
    blockedPhones: [],
    webhooks: [],
    editFilials: [],
    zones: [],
    payments: [],
    tags: [],
    articlesCash: [],
    articlesCashCategories: [],
    articlesExpenditures: [],
    add: {},
    sources: [],
    paging: {
      city: {
        start: 0,
        limit: 10
      },
      filial: {
        start: 0,
        limit: 10
      },
      blockedPhones: {
        start: 0,
        limit: 10
      },
      webhooks: {
        start: 0,
        limit: 10
      },
      payments: {
        start: 0,
        limit: 10
      },
      tags: {
        start: 0,
        limit: 10
      },
      articlesCash: {
        start: 0,
        limit: 10
      },
      articlesExpenditures: {
        start: 0,
        limit: 10
      },
      sources: {
        start: 0,
        limit: 10
      },
      articlesCashCategories: {
        start: 0,
        limit: 10,
      }
    },
    sorting: {
      city: {
        field: 'name',
        type: 'asc'
      },
      filial: {
        field: 'city',
        type: 'desc'
      },
      blockedPhones: {
        field: 'id',
        type: 'desc'
      },
      webhooks: {
        field: 'id',
        type: 'desc'
      }
    },
    count: {
      cities: 0,
      filials: 0,
      blockedPhones: 0,
      webhooks: 0,
      payments: 0,
      sources: 0,
      articlesCash: 0,
      articlesCashCategories: 0,
    },
    filters: {
        filial: {
            city: null
        }
    },
    city: {
      detail: {},
      edit: null
    },
    payment: {
      detail: {},
      edit: null,
    },
    tag: {
      detail: {},
      edit: null,
    },
    articleCash: {
      detail: {},
      edit: null,
    },
    articleExpenditures: {
      detail: {},
      edit: null,
    },
    filial: {
      detail: {},
      edit: null,
    },
    zone: {
      detail: {},
      edit: null,
    },
    source: {
      detail: {},
      edit: null,
    },
    articlesCashCategory: {
      detail: {},
      edit: null,
    }
};

export default function handbook(state = initialState, action) {
  switch(action.type) {    
    case 'SET_HANDBOOK_PAGING': {
      return {
          ...state,
          paging: {
            ...state.paging,
            [action.field]: action.paging
          }
      };
    }

    case 'SET_HANDBOOK_FILTERS': {
      return {
          ...state,
          filters: {
            ...state.filters,
            [action.field]: action.filters
          }
      };
    }

    case 'SET_HANDBOOK': {
      return {
          ...state,
          [action.field]: action.data
      };
    }

    case 'SET_HANDBOOK_DETAIL': {
      return {
        ...state,
        [action.field]: {
          ...state[action.field],
          detail: action.data
        }
      }
    }
    
    case 'SET_HANDBOOK_EDIT': {
      return {
        ...state,
        [action.field]: {
          ...state[action.field],
          edit: action.data
        }
      }
    }

    case 'SET_HANDBOOK_COUNT': {
      return {
          ...state,
          count: {
            ...state.count,
            [action.field]: action.count
          }
      };
    }

    case 'CHANGE_EDIT_FILIALS': {
      return {
          ...state,
          editFilials: state.editFilials.map(
            editFilial => {
              if (editFilial.id === action.data.id) {
                return action.data;
              }
              return editFilial;
            }
          )
      };
    }

    case 'ADD_EDIT_FILIALS': {
      return {
          ...state,
          editFilials: [...state.editFilials, action.data]
      };
    }

    case 'REMOVE_EDIT_FILIALS': {
      return {
         ...state,
         editFilials: state.editFilials.filter((editFilial) => editFilial.id !== action.data.id)
      };
    }

    case 'SET_ADD_HANDBOOK': {
      return {
          ...state,
          add: action.data
      };
    }

    case 'UPDATE_BLOCKED_PHONE': {
      return {
        ...state,
        blockedPhones: state.blockedPhones.map(item => 
          item.id === action.blockedPhones.id ? action.blockedPhones : item
        )
      };
    }

    case 'REMOVE_BLOCKED_PHONE': {
      return {
        ...state,
        blockedPhones: state.blockedPhones.filter(item => item.id !== action.id)
      };
    }

    case 'UPDATE_WEBHOOK': {
      return {
        ...state,
        webhooks: state.webhooks.map(item => 
          item.id === action.webhook.id ? action.webhook : item
        )
      };
    }

    case 'REMOVE_WEBHOOK': {
      return {
        ...state,
        webhooks: state.webhooks.filter(item => item.id !== action.id)
      };
    }

    default: return state;
  }
}